/**
 * Seções do app — cada uma corresponde a uma subrota `/app/{id}` (ver `App.tsx`).
 */

import { LEMBRETES_APP_NAV_LABEL } from '../presentation/constants/lembretes-calendario-copy';
import { MANUTENCOES_AGENDADAS_NAV_LABEL } from '../presentation/constants/manutencoes-agendadas-copy';

export const APP_SECTION = {
  DASHBOARD: 'dashboard',
  REGISTRAR_SERVICO: 'registrar-servico',
  SERVICOS: 'servicos',
  CLIENTES: 'clientes',
  LEMBRETES_ENVIADOS: 'lembretes-enviados',
  MANUTENCOES_AGENDADAS: 'manutencoes-agendadas',
  TESTAR_ENVIO: 'testar-envio',
  FAQ_SUPORTE: 'faq-suporte',
  MINHA_CONTA: 'minha-conta',
  PLANOS: 'planos',
} as const;

export type AppSectionId = (typeof APP_SECTION)[keyof typeof APP_SECTION];

export interface AppSectionItem {
  id: AppSectionId;
  label: string;
  iconName: string; // nome do ícone Heroicons (outline)
}

export const APP_SECTIONS: AppSectionItem[] = [
  { id: APP_SECTION.DASHBOARD, label: 'Início', iconName: 'HomeIcon' },
  { id: APP_SECTION.REGISTRAR_SERVICO, label: 'Registrar serviço', iconName: 'PlusCircleIcon' },
  { id: APP_SECTION.SERVICOS, label: 'Serviços', iconName: 'ListBulletIcon' },
  { id: APP_SECTION.CLIENTES, label: 'Clientes', iconName: 'UserGroupIcon' },
  { id: APP_SECTION.LEMBRETES_ENVIADOS, label: LEMBRETES_APP_NAV_LABEL, iconName: 'ChatBubbleLeftRightIcon' },
  { id: APP_SECTION.MANUTENCOES_AGENDADAS, label: MANUTENCOES_AGENDADAS_NAV_LABEL, iconName: 'CalendarDaysIcon' },
  { id: APP_SECTION.TESTAR_ENVIO, label: 'Configurações', iconName: 'Cog6ToothIcon' },
  { id: APP_SECTION.FAQ_SUPORTE, label: 'FAQ e Suporte', iconName: 'QuestionMarkCircleIcon' },
  { id: APP_SECTION.MINHA_CONTA, label: 'Minha conta', iconName: 'UserCircleIcon' },
  { id: APP_SECTION.PLANOS, label: 'Planos', iconName: 'CreditCardIcon' },
];

/** Grupos do menu (sidebar) para organizar as seções visualmente */
export interface AppMenuGroup {
  label: string;
  sectionIds: AppSectionId[];
}

export const APP_MENU_GROUPS: AppMenuGroup[] = [
  { label: 'Principal', sectionIds: [APP_SECTION.DASHBOARD, APP_SECTION.REGISTRAR_SERVICO, APP_SECTION.SERVICOS, APP_SECTION.CLIENTES] },
  {
    label: 'Lembretes',
    sectionIds: [
      APP_SECTION.LEMBRETES_ENVIADOS,
      APP_SECTION.MANUTENCOES_AGENDADAS,
      APP_SECTION.TESTAR_ENVIO,
    ],
  },
  { label: 'Ajuda', sectionIds: [APP_SECTION.FAQ_SUPORTE] },
];

/** Grupo exibido no rodapé do sidebar (acima de Sair): conta, plano, pagamentos */
export const APP_MENU_FOOTER_GROUP: AppMenuGroup = {
  label: 'Conta',
  sectionIds: [APP_SECTION.MINHA_CONTA, APP_SECTION.PLANOS],
};
